import {
  REQUEST_CREATE_CUSTOM_REPORT,
  RESPONSE_CREATE_CUSTOM_REPORT,
  REQUEST_CREATE_CUSTOM_REPORT_FAILURE,
  SELECT_CUSTOM_REPORT,
  UNSELECT_CUSTOM_REPORT,
  REQUEST_DELETE_CUSTOM_REPORT,
  RESPONSE_DELETE_CUSTOM_REPORT,
  REQUEST_DELETE_CUSTOM_REPORT_FAILURE,
  REQUEST_UPDATE_CUSTOM_REPORT_TITLE,
  RESPONSE_UPDATE_CUSTOM_REPORT_TITLE,
  REQUEST_UPDATE_CUSTOM_REPORT_TITLE_FAILURE,
  REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT,
  REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE,
  REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT,
  REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE,
  REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT,
  REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE,
  REQUEST_ADD_DASHBOARD_CUSTOM_REPORT,
  RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT,
  REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE,
  REQUEST_DELETE_FIELD_CUSTOM_REPORT,
  RESPONSE_DELETE_FIELD_CUSTOM_REPORT,
  REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE,
  REQUEST_ADD_FIELD_CUSTOM_REPORT,
  RESPONSE_ADD_FIELD_CUSTOM_REPORT,
  REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE,
  REQUEST_UPDATE_FIELD_CUSTOM_REPORT,
  RESPONSE_UPDATE_FIELD_CUSTOM_REPORT,
  REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE,
  REQUEST_SHIFT_FIELD_CUSTOM_REPORT,
  RESPONSE_SHIFT_FIELD_CUSTOM_REPORT,
  REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE,
  REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT,
  REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE,
  REQUEST_UPDATE_AXIS_CUSTOM_REPORT,
  RESPONSE_UPDATE_AXIS_CUSTOM_REPORT,
  REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE,
} from "../actions/customReportActions";

import { states } from "./queriesStates";

const initialState = {
  createCustomReportDataState: states.NOT_REQUESTED,
  deleteCustomReportDataState: states.NOT_REQUESTED,
  updateCustomReportTitleDataState: states.NOT_REQUESTED,
  deleteCustomReportDahsboardDataState: states.NOT_REQUESTED,
  shiftCustomReportDahsboardDataState: states.NOT_REQUESTED,
  addCustomReportDahsboardDataState: states.NOT_REQUESTED,
  updateCustomReportDahsboardDataState: states.NOT_REQUESTED,
  deleteCustomReportFieldDataState: states.NOT_REQUESTED,
  addCustomReportFieldDataState: states.NOT_REQUESTED,
  updateCustomReportFieldDataState: states.NOT_REQUESTED,
  updateCustomReportAxisDataState: states.NOT_REQUESTED,
  shiftCustomReportFieldDataState: states.NOT_REQUESTED,
  downloadExampleCustomReportDataState: states.NOT_REQUESTED,
  selectedCustomReportId: null,
  errors: [],
};

const customReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CREATE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        createCustomReportDataState: states.REQUEST,
      });
    }
    case RESPONSE_CREATE_CUSTOM_REPORT: {
      window.history.pushState({}, "", `/controls/reportConstructor/${action.data.id}`);
      return Object.assign({}, state, {
        createCustomReportDataState: states.READY,
        selectedCustomReportId: action.data.id,
      });
    }
    case REQUEST_CREATE_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        createCustomReportDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case SELECT_CUSTOM_REPORT: {
      window.history.pushState({}, "", `/controls/reportConstructor/${action.data}`);
      return Object.assign({}, state, {
        selectedCustomReportId: action.data,
      });
    }

    case UNSELECT_CUSTOM_REPORT: {
      window.history.pushState({}, "", `/controls/reportConstructor`);
      return Object.assign({}, state, {
        selectedCustomReportId: null,
      });
    }

    case REQUEST_DELETE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportDataState: states.REQUEST,
      });
    }
    case RESPONSE_DELETE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportDataState: states.READY,
      });
    }
    case REQUEST_DELETE_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        deleteCustomReportDataState: states.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_UPDATE_CUSTOM_REPORT_TITLE: {
      return Object.assign({}, state, {
        updateCustomReportTitleDataState: states.REQUEST,
      });
    }
    case RESPONSE_UPDATE_CUSTOM_REPORT_TITLE: {
      return Object.assign({}, state, {
        updateCustomReportTitleDataState: states.READY,
      });
    }
    case REQUEST_UPDATE_CUSTOM_REPORT_TITLE_FAILURE: {
      return Object.assign({}, state, {
        updateCustomReportTitleDataState: states.FAILURE,
      });
    }

    case REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportDahsboardDataState: states.REQUEST,
      });
    }
    case RESPONSE_DELETE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportDahsboardDataState: states.READY,
      });
    }
    case REQUEST_DELETE_DASHBOARD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        deleteCustomReportDahsboardDataState: states.FAILURE,
      });
    }

    case REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        shiftCustomReportDahsboardDataState: states.REQUEST,
      });
    }
    case RESPONSE_SHIFT_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        shiftCustomReportDahsboardDataState: states.READY,
      });
    }
    case REQUEST_SHIFT_DASHBOARD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        shiftCustomReportDahsboardDataState: states.FAILURE,
      });
    }

    case REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportDahsboardDataState: states.REQUEST,
      });
    }
    case RESPONSE_UPDATE_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportDahsboardDataState: states.READY,
      });
    }
    case REQUEST_UPDATE_DASHBOARD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        updateCustomReportDahsboardDataState: states.FAILURE,
      });
    }

    case REQUEST_ADD_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        addCustomReportDahsboardDataState: states.REQUEST,
      });
    }
    case RESPONSE_ADD_DASHBOARD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        addCustomReportDahsboardDataState: states.READY,
      });
    }
    case REQUEST_ADD_DASHBOARD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        addCustomReportDahsboardDataState: states.FAILURE,
      });
    }

    case REQUEST_DELETE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportFieldDataState: states.REQUEST,
      });
    }
    case RESPONSE_DELETE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        deleteCustomReportFieldDataState: states.READY,
      });
    }
    case REQUEST_DELETE_FIELD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        deleteCustomReportFieldDataState: states.FAILURE,
      });
    }

    case REQUEST_ADD_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        addCustomReportFieldDataState: states.REQUEST,
      });
    }

    case RESPONSE_ADD_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        addCustomReportFieldDataState: states.READY,
      });
    }

    case REQUEST_ADD_FIELD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        addCustomReportFieldDataState: states.FAILURE,
      });
    }

    case REQUEST_UPDATE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportFieldDataState: states.REQUEST,
      });
    }
    case RESPONSE_UPDATE_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportFieldDataState: states.READY,
      });
    }
    case REQUEST_UPDATE_FIELD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        updateCustomReportFieldDataState: states.FAILURE,
      });
    }

    case REQUEST_SHIFT_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        shiftCustomReportFieldDataState: states.REQUEST,
      });
    }
    case RESPONSE_SHIFT_FIELD_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        shiftCustomReportFieldDataState: states.READY,
      });
    }
    case REQUEST_SHIFT_FIELD_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        shiftCustomReportFieldDataState: states.FAILURE,
      });
    }

    case REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        downloadExampleCustomReportDataState: states.REQUEST,
      });
    }
    case RESPONSE_DOWNLOAD_EXAMPLE_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        downloadExampleCustomReportDataState: states.READY,
      });
    }
    case REQUEST_DOWNLOAD_EXAMPLE_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        downloadExampleCustomReportDataState: states.FAILURE,
      });
    }

    case REQUEST_UPDATE_AXIS_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportAxisDataState: states.REQUEST,
      });
    }
    case RESPONSE_UPDATE_AXIS_CUSTOM_REPORT: {
      return Object.assign({}, state, {
        updateCustomReportAxisDataState: states.READY,
      });
    }
    case REQUEST_UPDATE_AXIS_CUSTOM_REPORT_FAILURE: {
      return Object.assign({}, state, {
        updateCustomReportAxisDataState: states.FAILURE,
      });
    }


    default:
      return state;
  }
};

export default customReportReducer;
